exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".access-Table .sphere-table-container{position:relative}.access-Table .k-grid-container{max-height:Max(calc(100vh - 500px), 200px)}.access-Table .k-table-actions .v-btn.success{background:#00ce7c !important;border-color:#00ce7c !important;color:#fff !important}.access-Table .k-table-actions .v-btn.error{background:#ff4247 !important;border-color:#ff4247 !important;color:#fff !important}.access-Table .v-btn-toggle .theme--light.v-btn--active{background-color:#1976d2;color:#fff}\n", ""]);

// exports
